


export default function In() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3164_1038)">
        <path d="M17.872 0.76001H2.12435C1.36999 0.76001 0.76001 1.35556 0.76001 2.09187V17.9045C0.76001 18.6408 1.36999 19.24 2.12435 19.24H17.872C18.6264 19.24 19.24 18.6408 19.24 17.9081V2.09187C19.24 1.35556 18.6264 0.76001 17.872 0.76001ZM6.24265 16.5077H3.49953V7.6864H6.24265V16.5077ZM4.87109 6.48448C3.9904 6.48448 3.27935 5.77343 3.27935 4.89635C3.27935 4.01927 3.9904 3.30823 4.87109 3.30823C5.74817 3.30823 6.45921 4.01927 6.45921 4.89635C6.45921 5.76982 5.74817 6.48448 4.87109 6.48448ZM16.5077 16.5077H13.7682V12.2197C13.7682 11.1983 13.7501 9.8809 12.3425 9.8809C10.9168 9.8809 10.7002 10.9962 10.7002 12.1476V16.5077H7.96432V7.6864H10.5919V8.89193H10.628C10.9926 8.19893 11.8877 7.46623 13.2196 7.46623C15.9952 7.46623 16.5077 9.29257 16.5077 11.6675V16.5077Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_3164_1038">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
